import { useEffect } from 'react';
import { useCookieStore } from '../../state-management/cookieStore';

const useOneTrustConsent = (videoId?: string): string[] => {
  const { selectedCookies, setSelectedCookies } = useCookieStore();

  useEffect(() => {
    const cookieNames = [
      { name: 'Strictly Necessary', id: 'C0001' },
      { name: 'Performance', id: 'C0002' },
      { name: 'Functional', id: 'C0003' },
      { name: 'Targeting', id: 'C0004' },
      { name: 'Social Media', id: 'C0005' },
    ];

    const updateSelectedCookies = (groupsArray: string | string[]) => {
      const selected = cookieNames.filter((cookie) =>
        groupsArray.includes(cookie.id)
      );
      setSelectedCookies(selected.map((cookie) => cookie.name));
    };

    const handleConsentChange = (e: CustomEvent) => {
      const groupsArray = e.detail ?? [];
      updateSelectedCookies(groupsArray);
    };

    const handleInitialLoad = () => {
      const groupsArray =
        window.OnetrustActiveGroups?.split(',').filter(Boolean) ?? [];
      updateSelectedCookies(groupsArray);
    };

    if (window.OneTrust) {
      handleInitialLoad();
      window.OneTrust?.OnConsentChanged?.(handleConsentChange);
    } else {
      const timeoutId = setTimeout(() => {
        if (window.OneTrust) {
          handleInitialLoad();
          window.OneTrust?.OnConsentChanged?.(handleConsentChange);
        }
      }, 2000);

      return () => clearTimeout(timeoutId);
    }
  }, [videoId, setSelectedCookies]);

  return selectedCookies;
};

export default useOneTrustConsent;
